import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';

import { GlobalErrorService } from '../../../../error/global-error.service';

@Component({
  selector: 'remote-update-domain-app-server-error-page',
  templateUrl: './server-error-page.component.html',
  styleUrls: ['./server-error-page.component.css'],
  imports: [MatButton]
})
export class ServerErrorPageComponent {
  private serverErrorService = inject(GlobalErrorService);
  errorStatus = this.serverErrorService.errorStatus;

  async refreshPage() {
    this.serverErrorService.clearError();
    window.location.reload();
  }
}
